module.exports = __webpack_public_path__ + "images/payconiq.53f873f33b934a582f2a601cb73089d3.png";